import { Typography } from "@mui/material";
import { ArrowDropUp, Remove } from "@mui/icons-material";
import { Box } from "@mui/material";
import theme from "theme";

export const PercentageBlock = ({
  averageToFormat,
  value,
  arrowDirection,
  ...props
}: {
  averageToFormat: number;
  value: string;
  arrowDirection: "up" | "down" | "none";
} & Record<string, any>) => {
  const { sx, ...rest } = props;

  return (
    <Box
      sx={{
        borderRadius: "8px",
        padding: "2px 4px",
        border: `1px solid ${theme.palette.border.dark}`,
        bgcolor:
          averageToFormat === 0
            ? theme.palette.surface["silver"]
            : averageToFormat > 0
            ? theme.palette.system["green"]
            : theme.palette.system["red"],
        width: "fit-content",
        ...sx,
      }}
      {...rest}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          position: "relative",
          minWidth: "52px",
        }}>
        {arrowDirection === "none" ? (
          <Remove
            sx={{
              position: "absolute",
              left: theme.spacing(-0.75),
              width: "12px",
              marginLeft: "4px",
            }}
          />
        ) : (
          <ArrowDropUp
            sx={{
              position: "absolute",
              left: theme.spacing(-0.75),
              transform: arrowDirection === "down" ? "rotate(180deg)" : "none",
            }}
          />
        )}
        <Typography variant="body-sm" marginLeft={averageToFormat !== 0 ? theme.spacing(2) : 0}>
          {value}%
        </Typography>
      </Box>
    </Box>
  );
};

export default PercentageBlock;
